'use client'

import MobileNumberInput from '@components/ContactUs/PhoneInput'
import Modal from '@components/Modal'
import { Container, Flex } from '@quark/layout'
import { BrandVars } from '@quark/theme'
import { Text } from '@quark/typography'
import React, { useEffect, useState } from 'react'
import QRCode from 'react-qr-code'
import {
  FALLBACK_CTA_TEXT,
  FALLBACK_PLACEHOLDER,
  INPUT_ERROR_MESSAGE,
  PHONE_NUMBER_REGEX,
  SEND_APPLINK_WHATSAPP_ENDPOINT,
} from '@components/HomePage/DownloadAppModal/constants'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { homePageCommonProps } from '@utils/segmentProperties'
import { widgetCommonSegmentProperties } from '@components/HomePage/utils/SegmentEventConstants'
import { GET_HCAPTCHA_TOKEN_EVENT, LOAD_HCAPTCHA_EVENT } from '@constants/customEvents'
import { doToast } from '@components/utils/toast'
import { ERROR, ERROR_MESSAGE, SUCCESS, SUCCESS_MESSAGE } from '@constants/toast'
import Toast from '@components/Toast/toast'
import { HomeComponentType } from '@components/HomePage/utils/HomeComponentType'
import { Close } from '@quark/icons'
import logger from '@utils/logger'
import PrimaryButton from '../PrimaryButton/Button'
import styles from './stickyCarousel.module.scss'

const DesktopModal = ({ show, setShow, modalData }) => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [token, setToken] = useState<string>('')
  const [phoneNumberValid, setPhoneNumberValid] = useState(true)
  const [toastText, setToastText] = useState('')
  const [toastType, setToastType] = useState('')

  const handlePhoneNumberChanged = (e: any) => {
    setPhoneNumber(e.target.value)
    setPhoneNumberValid(true)
  }

  const handleInputBlur = () => {
    void trackEvent('wrapper_input_phone_entered', {
      ...homePageCommonProps(),
      ...widgetCommonSegmentProperties({ widgetType: HomeComponentType.DownloadAppBanner }),
      phone: phoneNumber,
    })
    const isValidPhoneNumber = PHONE_NUMBER_REGEX.test(phoneNumber)
    setPhoneNumberValid(isValidPhoneNumber)
    if (!isValidPhoneNumber) {
      void trackEvent('feedback_error_message', {
        ...homePageCommonProps(),
        ...widgetCommonSegmentProperties({ widgetType: HomeComponentType.DownloadAppBanner }),
      })
    }
  }
  useEffect(() => {
    if (show) {
      const hcaptchEvent = new CustomEvent(LOAD_HCAPTCHA_EVENT, {
        detail: true,
      })
      document.dispatchEvent(hcaptchEvent)
      logger.info('HI i am inside desktop modal')
    }
  }, [show])

  const onCtaClick = async () => {
    const isPhoneNumberValid = PHONE_NUMBER_REGEX.test(phoneNumber)
    setPhoneNumberValid(isPhoneNumberValid)
    if (!isPhoneNumberValid) return

    try {
      const isValidPhoneNumber = PHONE_NUMBER_REGEX.test(phoneNumber)
      if (!isValidPhoneNumber) {
        setPhoneNumberValid(isValidPhoneNumber)
        return
      }
      const response = await fetch(SEND_APPLINK_WHATSAPP_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-captcha-token': token,
        },
        body: JSON.stringify({
          phone: phoneNumber,
          componentType: modalData?.type || HomeComponentType.DownloadAppBanner,
        }),
      })
      if (response.ok) {
        void trackEvent('btn_get_app_link', {
          ...homePageCommonProps(),
          ...widgetCommonSegmentProperties({ widgetType: HomeComponentType.DownloadAppBanner }),
          funnel: 'entry',
        })
        setToken('')
        doToast({ message: SUCCESS_MESSAGE, type: SUCCESS, setToastText, setToastType })
        setShow(false)
      } else {
        logger.error('Whatsapp communication failed')
        doToast({ message: ERROR_MESSAGE, type: ERROR, setToastText, setToastType })
        setShow(false)
      }
    } catch (err) {
      doToast({ message: ERROR_MESSAGE, type: ERROR, setToastText, setToastType })
      logger.error('Whatsapp communication api call error', err)
      setShow(false)
    }
  }

  const onFormSubmit = event => {
    event.preventDefault()
    void onCtaClick()
  }

  useEffect(() => {
    document.addEventListener(GET_HCAPTCHA_TOKEN_EVENT, handleGetHcaptchaToken)

    return () => {
      document.removeEventListener(GET_HCAPTCHA_TOKEN_EVENT, handleGetHcaptchaToken)
    }
  }, [])
  const handleGetHcaptchaToken = (e: CustomEvent) => {
    setToken(e.detail.token)
  }

  return (
    <Modal show={show} setShow={setShow} className={styles.modal}>
      <Close color={BrandVars.text['base/primary']} height="20" width="20" onClick={() => setShow(false)} />
      <Container backgroundColor="base/elevated" padding="spacing-56" textAlign="center" borderRadius="radius-6xl">
        <Flex flexDirection="column" alignItems="center" gap="spacing-24">
          <Flex flexDirection="column" gap="spacing-8">
            <Text fontStyle="um_text-4xl/bold" color="base/primary" whiteSpace="pre">
              {modalData?.title}
            </Text>
            <Text fontStyle="um_text-sm/normal" color="base/secondary">
              {modalData?.description}
            </Text>
          </Flex>
          <QRCode
            size={140}
            value={modalData?.link}
            fgColor={BrandVars.text['base/primary']}
            bgColor={BrandVars.Surface['base/elevated']}
          />
          <Flex size="fullWidth" flexDirection="column" gap="spacing-24">
            <form onSubmit={onFormSubmit}>
              <MobileNumberInput
                labelText={FALLBACK_PLACEHOLDER}
                hasError={!phoneNumberValid}
                onChange={handlePhoneNumberChanged}
                onBlur={handleInputBlur}
                errMsg={INPUT_ERROR_MESSAGE}
              />
            </form>
            <PrimaryButton onButtonClick={onCtaClick} text={FALLBACK_CTA_TEXT} disabled={!token} />
          </Flex>
        </Flex>
      </Container>
      <Toast isMobile={false} message={toastText} toastType={toastType} />
    </Modal>
  )
}

export default DesktopModal
